import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import './globals.css';
import MainComponent from './components/dashboard';
import Login from './components/LoginPage/login';
import Main from './components/Dashboard/main';
import Signup from './components/SignupPage/signup';
import Utilization from './components/CardUtilization/utilization';
import reportWebVitals from './reportWebVitals';
import PrivateRoute from './components/PrivateComponent';
import RemoveCollections from './components/RemoveCollections/RemoveCollections';
import RemovePublicRecords from './components/RemovePublicRecords/RemovePublicRecords';
import Subscription from './components/Subscription/Subscription';
import ComingSoon from './components/CommingSoon/CommingSoon';
import OptByEmail from './components/OptByEmail/OptByEmail';
import OptByMail from './components/OptByMail/OptByMail';
import SendMail from './components/SendMail/SendMail';
import CreditCoach from './components/CreditCoach/CreditCoach';
import { EnterEmail } from './components/ForgetPassword/EnterEmail';
import { ResetPassword } from './components/ForgetPassword/ResetPassword';
import ScoreSimulator from './components/ScoreSimulator/ScoreSimulator';



const App = () => {


  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return localStorage.getItem('isAuthenticated') === 'true';
  });

  useEffect(() => {
    localStorage.setItem('isAuthenticated', isAuthenticated);
  }, [isAuthenticated]);
  const auth = localStorage.getItem('isAuthenticated')
  const token = localStorage.getItem('Token')

  return (
    <div>
      <Routes>

        {!auth || auth === false || !token ? (
          <>
            <Route path='/app/reset-password-email' element={<EnterEmail/>} />
            <Route path='/app/reset-password' element={<ResetPassword/>} />
            <Route path="*" element={<Login setIsAuthenticated={setIsAuthenticated}/>} />
            <Route path="/app/" element={<Login setIsAuthenticated={setIsAuthenticated}/>} />
            <Route path="/app/signup" element={<Signup setIsAuthenticated={setIsAuthenticated} />} />
            <Route path="/app/login" element={<Login setIsAuthenticated={setIsAuthenticated}  />} />

          </>
        ) : (
          <Route element={<PrivateRoute isAuthenticated={isAuthenticated} />}>
            <Route path="*" element={<CreditCoach />} />
            {/* <Route path="/app/dashboard" element={<Main/>} /> */}
            <Route path="/app/utilization" element={<Utilization />} />
            <Route
              path='/app/remove-collections'
              element={<RemoveCollections />}
            />
            <Route path='/app/credit-coach' element={<CreditCoach />} />
            <Route path='/app/remove-public-records' element={<RemovePublicRecords />} />
            <Route path='/app/subscription' element={<Subscription />} />
            <Route path='/app/mail' element={<SendMail />} />
            <Route path='/app/opt-email' element={<OptByEmail />} />
            <Route path='/app/opt-mail' element={<OptByMail />} />
            <Route path='/app/score-simulator' element={<ScoreSimulator/>}/>
          </Route>
        )}
      </Routes>

    </div>
  )
}

export default App

